// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"752c0aa4","57":"ef374b60","253":"27c48d2f","453":"b92a0a37","834":"c40236a4"}[chunkId] + ".chunk.js";
};